export const EnableMotionClipsDefinitions = [
  {
    value: 'true',
    details: 'Xirgocam will automatically create clips based on harsh/hard events'
  },
  {
    value: 'false',
    details: 'Xirgocam will NOT create clips based on harsh/hard motion events'
  }
]